import { render } from "./AccountNumByUser.vue?vue&type=template&id=213a93aa"
import script from "./AccountNumByUser.vue?vue&type=script&lang=js"
export * from "./AccountNumByUser.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__